import * as React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

import { Button, DesignToken, Heading, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { IWithBreakpointsProps, withBreakpoints } from "helpers/withBreakpoints";
import { selectIsAdmin } from "store/entities/agents";
import {
  selectHasDoneLiveChatSelectiveImportBefore,
  selectHasEverDoneFullLiveChatDataImport,
} from "store/entities/integrations";
import { withVar } from "themes/helpers";

import IconsPair from "./IconsPair";

interface IProps {
  currentStep: number;
  imageSource: string;
  title: React.ReactElement | string;
  subtitle: React.ReactElement | string;
  content?: React.ReactElement;
  nextButton?: React.ReactElement;
  nextButtonRouteLink?: string;
  backButtonRouteLink?: string;
  backButtonDisabled?: boolean;
  firstIcon?: React.ReactElement;
  secondIcon?: React.ReactElement;
  nextButtonHandler?: () => void;
}

const TitleOnboardingStep: React.FC<IProps & IWithBreakpointsProps> = ({
  currentStep,
  title,
  subtitle,
  content,
  imageSource,
  firstIcon,
  secondIcon,
  backButtonDisabled,
  backButtonRouteLink,
  nextButtonRouteLink,
  nextButton,
  isMobile,
}) => {
  const hasEverDoneSelectiveImport = useSelector(selectHasDoneLiveChatSelectiveImportBefore);
  const hasEverDoneFullImport = useSelector(selectHasEverDoneFullLiveChatDataImport);
  const isOwner = useSelector(selectIsAdmin);
  const history = useHistory();

  const shouldDisplayFourSteps = isOwner && !hasEverDoneFullImport && !hasEverDoneSelectiveImport;

  const handleButtonClick = (url: string): void => {
    history.push(url);
  };

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      height="100%"
      overflow="scroll"
      bg={withVar(DesignToken.SurfacePrimaryDefault)}
    >
      <Flex width="890px" padding="20px" gap="32px" minHeight={isMobile ? "550px" : "540px"}>
        <Flex column paddingBottom={isMobile ? "0" : "32px"} width="100%">
          <Text
            customColor={withVar(DesignToken.ContentBasicSecondary)}
            css={{ marginBottom: withVar(SpacingToken.Spacing8) }}
          >
            Step {currentStep} of {shouldDisplayFourSteps ? 4 : 3}
          </Text>
          <Flex maxWidth="445px" column>
            {firstIcon && secondIcon && <IconsPair firstIcon={firstIcon} secondIcon={secondIcon} />}
            {title}
            <Heading
              size="xs"
              bold
              customColor={withVar(DesignToken.ContentBasicSecondary)}
              css={{ maxWidth: "365px" }}
            >
              {subtitle}
            </Heading>
            {content}
          </Flex>
          <Flex gap="8px" marginTop="auto">
            <Button
              size="large"
              kind="secondary"
              disabled={backButtonDisabled}
              // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
              onClick={() => handleButtonClick(backButtonRouteLink)}
            >
              Back
            </Button>
            {nextButton || (
              // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
              <Button size="large" kind="primary" onClick={() => handleButtonClick(nextButtonRouteLink)}>
                Continue
              </Button>
            )}
          </Flex>
        </Flex>
        {!isMobile && <img width="445px" height="540px" src={imageSource} alt="" loading="eager" />}
      </Flex>
    </Flex>
  );
};

export default withBreakpoints(TitleOnboardingStep);
